<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
      <div class="text-center">
        <!-- Icon -->
        <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        
        <!-- Titel -->
        <h2 class="text-xl font-semibold text-gray-900 mb-2">
          Standortzugriff erforderlich
        </h2>
        
        <!-- Beschreibung -->
        <p class="text-gray-600 mb-6">
          Die Raga Cars App benötigt Standortzugriff für die korrekte Funktionalität. 
          Ihr Standort wird für die Terminal-Erkennung und optimale Arbeitsabläufe benötigt.
        </p>
        
        <!-- Zusätzliche Info -->
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
          <div class="flex items-start">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div class="text-sm text-gray-600">
              <p class="font-medium mb-1">Warum benötigen wir Ihren Standort?</p>
              <ul class="space-y-1 text-xs">
                <li>• Automatische Terminal-Erkennung</li>
                <li>• Optimale Arbeitsabläufe</li>
                <li>• Verbesserte App-Funktionalität</li>
              </ul>
            </div>
          </div>
        </div>
        
        <!-- Buttons -->
        <div class="space-y-3">
          <button
            @click="requestLocationPermission"
            :disabled="isRequesting"
            class="w-full py-3 px-4 bg-[#E9041D] text-white rounded-lg hover:bg-red-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            <svg v-if="isRequesting" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span v-if="isRequesting">Prüfe Standortzugriff...</span>
            <span v-else>Standortzugriff erlauben</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { requestLocationPermission as requestLocationPermissionFromComposable } from '../composables/useLocation'

const emit = defineEmits<{
  'permission-granted': []
  'permission-denied': []
}>()

const isRequesting = ref(false)

// Fordere Standortzugriff an
const requestLocationPermission = async () => {
  isRequesting.value = true
  
  try {
    // Verwende die Funktion aus dem Composable, die localStorage speichert
    const success = await requestLocationPermissionFromComposable()
    
    if (success) {
      console.log('Standortzugriff erfolgreich gewährt')
      emit('permission-granted')
    } else {
      console.log('Standortzugriff verweigert')
      emit('permission-denied')
    }
    
  } catch (error) {
    console.error('Fehler beim Anfordern des Standortzugriffs:', error)
    emit('permission-denied')
  } finally {
    isRequesting.value = false
  }
}

// Prüfe beim Mounten den aktuellen Status
onMounted(async () => {
  // Keine automatische Prüfung mehr - die App.vue kümmert sich um die Logik
})
</script> 